import {createContext} from 'react'

const AnaquelesContext = createContext()

export default AnaquelesContext